import styled from 'styled-components';
import { Container as MuiContainer } from '@mui/material';

// Estilização do Container principal
export const Container = styled(MuiContainer)`
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
`;

// Título principal
export const Title = styled.h2`
  color: #333;
  margin-bottom: 20px;
`;

// Estilização do botão
export const AddButton = styled.button`
  background-color: #1976d2;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;

  &:hover {
    background-color: #1565c0;
  }
`;

// Wrapper para o switch de convidados
export const GuestToggleWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
`;

// Mensagem do snackbar
export const SnackbarMessage = styled.div`
  display: flex;
  align-items: center;
`;

// Loader de carregamento
export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
`;

// Estilização da tabela
export const TableWrapper = styled.div`
  margin-top: 20px;

  .MuiTable-root {
    background-color: white;
  }

  .MuiTableCell-head {
    font-weight: bold;
  }
`;

// Botão de ação na tabela
export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #1976d2;

  &:hover {
    color: #1565c0;
  }
`;

// Estilização do diálogo
export const DialogContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
`;

// Estilização dos campos de texto
export const StyledTextField = styled.input`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  width: 100%;
  margin-bottom: 10px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #1976d2;
  }
`;
